import React, { type ForwardedRef, forwardRef } from 'react';

import { type InputNumberProps } from './InputNumber.types';
import { maxWithinBounds, STEP } from './InputNumber.utilities';

import { PrimitiveInputNumber } from './InputNumber.style';

function InputNumberComponent(
    {
        value,
        min,
        max,
        step = STEP.DEFAULT,
        disabled = false,
        error = false,
        readOnly = false,
        ariaLabel,
        onBlur,
        onFocus,
        onChange,
        ...rest
    }: InputNumberProps,
    ref: ForwardedRef<HTMLInputElement>,
) {
    const safeMax = maxWithinBounds({ min, max });
    const safeStep = Math.max(STEP.MIN, step);

    const noInteraction = Boolean(disabled || readOnly);

    return (
        <PrimitiveInputNumber
            ref={ref}
            {...rest}
            data-input-error={error ? true : undefined}
            // Fallback to empty string in order to prevent "uncontrolled component" switch.
            value={value ?? ''}
            min={min}
            max={safeMax}
            step={safeStep}
            aria-label={ariaLabel}
            disabled={Boolean(disabled || !onChange)}
            readOnly={Boolean(readOnly || !onChange)}
            onBlur={noInteraction ? undefined : onBlur}
            onFocus={noInteraction ? undefined : onFocus}
            onChange={noInteraction ? undefined : onChange}
        />
    );
}

export const InputNumber = forwardRef(InputNumberComponent);
